export interface RegistrationFormStatusInput {
  registrationFormSigned?: boolean;
  email?: string;
}

export interface RegistrationFormPresentation {
  signed: boolean;
  title: "Müşteri imzaladı" | "Henüz imzalamadı";
  description: string;
  tone: "signed" | "pending";
}

export function registrationFormPresentation(
  input: RegistrationFormStatusInput
): RegistrationFormPresentation {
  if (input.registrationFormSigned) {
    return {
      signed: true,
      title: "Müşteri imzaladı",
      description: "Kayıt formu e-posta eşleşmesiyle doğrulandı.",
      tone: "signed"
    };
  }

  return {
    signed: false,
    title: "Henüz imzalamadı",
    description: input.email?.trim()
      ? "Müşterinin tamamlanmış kayıt formu bulunmuyor."
      : "Eşleştirme için müşteri kartına e-posta adresi ekleyin.",
    tone: "pending"
  };
}
